{
  "paid-by-borrower": "Pagado por el prestatario",
  "paid-by-seller": "Pagado por el vendedor",
  "description": "Descripción",
  "payee": "Tenedor",
  "at-closing": "Al cierre",
  "before-closing": "Antes de cerrar",
  "by-others": "Por otros",
  "totals": "Totales",
  "additional-row": "fila adicional",
  "clear": "Limpiar",
  "charges": "Cargos",
  "prepaids": "Prepagos",
  "escrow": "Depósito",
  "lender-credits": "Créditos de prestamista",
  "debits-and-credits": "Débitos y Créditos",
  "days_per_year": "Dias por año",
  "edit-premium-line": "Editar Linea Premium En la sección Información de póliza",
  "interest-rate": "Tasa de Interés",
  "addendum": "Apéndice",
  "k-due-borrower": "K. Adeudado por el prestatario al cierre",
  "adjustments": "Ajustes",
  "adjustments-for-items": "Ajustes por artículos pagados por el vendedor por adelantado",
  "m-due-seller": "M. A pagar al vendedor al cierre",
  "statement-text": "Texto de declaración",
  "l-paid-already": "L. Pagado ya por o en nombre del prestatario al cierre",
  "other-credits": "Otros Creditos",
  "adjustments-for-items-updaid": "Ajustes por artículos no pagados por el vendedor",
  "deposit": "Deposito",
  "loan-amount": "Monto del préstamo",
  "lender": "Prestador",
  "settlement-agency": "Agencia de liquidación",
  "other": "Otro",
  "none": "Ninguno",
  "n-due-seller": "N. Vencimiento del vendedor al cierre",
  "label": "Etiqueta",
  "payments": "Pagos",
  "payment": "Pago",
  "routing": "Routing",
  "account": "Cuenta",
  "reference": "Referencia",
  "transfer": "Transferencia",
  "holdback": "Retención",
  "check": "Cheque",
  "wire": "Wire",
  "net-funded": "Financiado Neto",
  "aggregate": "Agregado",
  "current-total": "Total Actual",
  "add-document": "Agregar documento",
  "per-month": "por Mes",
  "number-of-month": "de Mes.",
  "to-others": "Hacia Otros",
  "send-title-charges-to": "Enviar Cargos de Título a",
  "summary-jk": "Resumen de transacciones",
  "gross-amount-due": "Monto bruto adeudado por el prestatario",
  "gross-due-seller": "Monto bruto debido al vendedor",
  "no-disbursements-yet": "No hay desembolsos todavia",
  "payment-details": "Detalles de Pago",
  "add-disbursement": "Agregar Desembolso",
  "no-items-to-show": "No hay elementos para mostrar",
  "remove-association": "Eliminar pagador",
  "edit-association": "Editar pagador",
  "error-loading-document-charges": "Tenemos un error al intentar obtener la información del documento.",
  "charges-collected": "Información recopilada del documento",
  "tax": "Impuesto",
  "add-entry": "Agregar Entrada",
  "select-payees": "Seleccionar Beneficiarios",
  "select-payers": "Seleccionar Pagadores",
  "select-parties": "Seleccionar Partes",
  "select-proprietors": "Seleccionar Propietarios",
  "select-ownerships": "Seleccionar Titularidades",
  "toggleParties": "Mostrar partes",
  "noEntries": "Aún no hay entradas",
  "noParties": "Aún no hay partes asignadas",
  "update-charges": "Actualizar Cargos",
  "success-updated": "Cargos Actualizados",
  "error-updated": "Error al Actualizar los Cargos",
  "verify-charges": "Por favor verificar antes de agregar cargos al pedido, los cargos marcados en azul ya estan en la orden",
  "success-deleted": "Cargo eliminado exitosamente",
  "error-deleted": "Error al eliminar el cargo",
  "commissions":"Comisiones",
  "charges-before":"los cargos marcados en azul estaban ya en la orden y no se pueden eliminar hasta en las pantallas del sistema, despues aparecen los cargos que se encuentran en el documento.",
  "deleteChargeTitle": "Eliminar Cargo",
  "deleteChargeConfirmation": "¿Está seguro de que desea eliminar este cargo? Esta acción no se puede deshacer y se perderá toda la información asociada.",
  "document-deleted": "Documento Eliminado",
  "edit-document": "Editar Documento",
  "add-document": "Agregar Documento",
  "amount-details": "Detalles del Monto",
  "closing-cost-subtotal": "Subtotal de Costos de Cierre",
  "paymentInfo": "Información de Pago",
  "partySearchAndCreation": "Búsqueda y creación de partes (para aquellas que aún no están en la orden o en el sistema)",
  "partiesSelected": "Partes Seleccionadas",
  "beforeClosing": "Antes del Cierre",
  "atClosing": "Al Cierre",
  "pricesOfTDISelected": "Precios del TDI seleccionado:",
  "txLabel": "TX",
  "chargeSettings": "Configuración de Cargos",
  "addNew": "Agregar Nuevo",
  "priceOfFirstPage": "Precio de la Primera Página",
  "pricePerPage": "Precio por Página",
  "extraPages": "Páginas Extra",
  "priceOfAdditionalPages": "Precio de Páginas Adicionales",
  "namesIncluded": "Nombres Incluidos",
  "pricePerExtraName": "Precio por Nombre Extra",
  "priceOfAdditionalNames": "Precio de Nombres Adicionales",
  "endorsement": "Endoso",
  "paidByBorrower": "Pagado por el Prestatario",
  "paidBySeller": "Pagado por el Vendedor",
  "document": "Documento",
  "amount": "Monto",
  "totalAmount": "Monto total",
  "chargeDetails": "Detalles del cargo",
  "showDetails": "Mostrar detalles",
  "hideDetails": "Ocultar detalles",
  "buyerAtClosing": "Comprador al cierre",
  "buyerBeforeClosing": "Comprador antes del cierre",
  "sellerAtClosing": "Vendedor al cierre",
  "sellerBeforeClosing": "Vendedor antes del cierre",
  "months": "Meses",
  "endorsementCode": "Código: {{code}}",
  "deleteChargeAriaLabel": "Eliminar cargo",
  "changePayers": "Cambiar Pagadores",
  "changePayees": "Cambiar Beneficiarios",
  "noPayees": "Sin beneficiarios asignados",
  "noPayers": "Sin pagadores asignados",
  "changeTaxes": "Cambiar Impuestos",
  "noTaxes": "Sin impuestos asignados",
  "mobileStepSelectCharges": "Seleccionar Cargos",
  "mobileStepSelectParties": "Seleccionar Partes",
  "mobileStepConfigureAmounts": "Configurar Montos",
  "mobileStepReviewCharges": "Revisar Cargos",
  "mobileSelectedCount": "{{count}} seleccionado(s)",
  "mobileSearchParties": "Buscar partes",
  "mobileReviewChargesTitle": "Cargos a Actualizar",
  "change-all": "Cambiar todos:",
  "taxes": "Impuestos",
  "tab-origination-charges": "Cargos de originación",
  "tab-did-not-shop-for": "Servicios que no buscó",
  "tab-did-shop-for": "Servicios que buscó",
  "tab-taxes-and-fees": "Impuestos y cargos",
  "tab-prepaids": "Prepagos",
  "tab-escrow": "Depósito en garantía",
  "tab-other-charges": "Otros cargos",
  "tab-lender-credits": "Créditos del prestamista",
  "tab-debits-and-credits": "Débitos y créditos",
  "tab-summary-of-transactions": "Resumen de transacciones",
  "tab-commissions": "Comisiones",
  "tab-loan-charges": "Cargos del préstamo",
  "tab-prepaid-items": "Partidas prepagadas",
  "tab-impounds": "Reservas en depósito",
  "tab-title-charges": "Cargos de título",
  "tab-recording-charges": "Cargos de registro",
  "tab-additional-charges": "Cargos adicionales"
}